import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';
import { Section } from '../../../views/sections/builders/section_builder';

interface ISectionSelectionsModel {
  sectionIds: Set<Section['id']>;
}

export type SectionSelectionsModel = ITypedModel<ISectionSelectionsModel>;

angular.module('capability-ng-scheduler').factory('ngSectionSelectionsModel', () => {
  return new Model<ISectionSelectionsModel>({
    sectionIds: new Set()
  });
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/section_selections/models/section_selections_model.ts